/** Shared right-side Contextual Creation Rail for any usable image media
 * card (imported Image Asset, completed Generate Image result, Try-On).
 *
 * TASK-00584: thin wrapper over the Admin-driven
 * `CanvasResultQuickActionRail`. Which of image / video / text show, and
 * in what order, comes ONLY from Platform Admin's Quick Action config
 * (enabled + sort_order) intersected with tenant catalog availability —
 * this component no longer owns a hardcoded action list or a per-node
 * "include text" switch. Icons resolve from the Function Registry target
 * node_type. */

import type { MouseEvent as ReactMouseEvent } from 'react'
import { useTranslation } from 'react-i18next'
import CanvasResultQuickActionRail from './CanvasResultQuickActionRail'

export type MediaWorkflowSourceNodeType = 'image_asset' | 'generate_image' | 'generate_tryon'

interface Props {
  /** Source node type — selects which Admin Quick Action rows apply. */
  sourceNodeType: MediaWorkflowSourceNodeType
  onQuickGenerate: (kind: 'image' | 'video' | 'text') => void
  /** Optional hover-bridge hooks (Generate Image Result-zone activation). */
  onMouseEnter?: () => void
  onMouseLeave?: () => void
  className?: string
}

export default function MediaWorkflowRail({
  sourceNodeType,
  onQuickGenerate,
  onMouseEnter,
  onMouseLeave,
  className,
}: Props) {
  const { t } = useTranslation('canvas')
  const fire = (kind: 'image' | 'video' | 'text') => (e: ReactMouseEvent) => {
    e.stopPropagation()
    onQuickGenerate(kind)
  }
  return (
    <CanvasResultQuickActionRail
      sourceNodeType={sourceNodeType}
      className={className}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      railTestId="media-workflow-rail"
      plainIcons
      actionHandlers={[
        { targetNodeType: 'generate_image', onClick: fire('image'), tooltip: t('workflowRail.continueGenerateImage') },
        { targetNodeType: 'generate_video', onClick: fire('video'), tooltip: t('workflowRail.continueGenerateVideo') },
        { targetNodeType: 'generate_text', onClick: fire('text'), tooltip: t('workflowRail.analyzeImage') },
      ]}
    />
  )
}
